module.exports = __webpack_public_path__ + "img/logo.f3350a5c.svg";